<template>
  <div>
    <checkout-cart-row
                       :hide-recurring-price="hideRecurringPrice"
                       heading-only/>
    <checkout-cart-row v-for="(product, index) in filteredProducts"
                       :key="product.product.code + index.toString()"
                       :has-delete="product.canRemove"
                       :height-emphasized="['TARIFF', 'DEVICE'].includes(product.productOfferingType)"
                       :hide-recurring-price="hideRecurringPrice"
                       @delete-item="handleItemDelete(product)">
      <template #name>
        <checkout-row-product :product-image="getProductImage(product)"
                              :product-name="product.product.name"
                              :has-info-button="product.productOfferingType === 'TARIFF'"
                              :has-tooltip="!['TARIFF', 'DEVICE'].includes(product.productOfferingType)"
                              :product-tooltip="product.product.description"
                              :product-brand="getProductBrand(product)"
                              :product-color="getProductColor(product)"
                              :product-summary="getProductSummary(product)"
                              @info-click="handleInfoClick(product)"/>
      </template>
      <template #recurring-price>
        <product-price
            v-if="product.monthlyPrice && product.monthlyPrice.cycleEnd"
            :months="product.monthlyPrice && product.monthlyPrice.cycleEnd"
            :price="getProductPrice(product, 'monthlyPrice')"/>
      </template>
      <template #recurring-old-price>
        <product-price v-if="product.monthlyPrice && product.monthlyPrice.oldPrice"
                       :months="product.monthlyPrice && product.monthlyPrice.oldPriceCycleEnd"
                       :price="getProductPrice(product, 'monthlyPrice', 'oldPrice')"/>
      </template>
      <template #price>
        <div class="free-e-sim-label" v-if="isFreeESimSrb && isFree(product)">{{ $t('checkout.free') }}</div>
        <product-price v-else :price="getProductPrice(product, 'oneTimePrice')"/>
      </template>
    </checkout-cart-row>
  </div>
</template>

<script>
import ProductPrice from '../../common/product-price'
import CheckoutRowProduct from './checkout-row-product'
import CheckoutCartRow from './checkout-cart-row'
import { prepaidTourist } from '@/config/constants'

export default {
  name: 'checkout-cart-products',
  components: { ProductPrice, CheckoutRowProduct, CheckoutCartRow },
  props: {
    products: {
      type: Array,
      default: () => []
    },
    hideRecurringPrice: {
      type: Boolean,
      default: false
    },
    isFreeESimSrb: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    filteredProducts () {
      if (this.isFromQrCode) {
        return this.products.filter(item => item.product.code.toLowerCase() !== 'esim')
      } else {
        return this.products
      }
    },
    isFromQrCode () {
      return prepaidTourist.isFromQrCode
    }
  },
  methods: {
    getProductSummary (product) {
      return product?.product?.summary || ''
    },
    getProductImage (product) {
      return (product?.product?.images && product?.product?.images[0]?.url) || null
    },
    getProductBrand (product) {
      return (product?.product?.brands && product?.product?.brands[0]?.name) || null
    },
    getProductColor (product) {
      if (product?.variant?.variantOptionQualifiers && product?.variant?.variantOptionQualifiers[0]?.image) {
        return {
          type: 'image',
          value: product.variant.variantOptionQualifiers[0].image.url
        }
      } else if (product?.variant?.variantOptionQualifiers && product?.variant?.variantOptionQualifiers[0]?.colorCode) {
        return {
          type: 'color',
          value: product.variant.variantOptionQualifiers[0].colorCode
        }
      } else {
        return null
      }
    },
    getProductPrice (product, priceType = 'oneTimePrice', price = 'price') {
      return (product[priceType] && product[priceType][price].formattedValue) || null
    },
    isFree (product) {
      return product?.oneTimePrice?.price?.value === 0
    },
    handleInfoClick (product) {
      console.log('info click', product)
    },
    handleItemDelete (product) {
      this.$emit('delete-item', product.entryNumber, product)
    }
  }
}
</script>

<style scoped>
  .free-e-sim-label {
    font-weight: 500;
  }
</style>
